import useRisksmartUser from '@risksmart-app/components/src/hooks/useRisksmartUser';
import { useAmplitude } from '@risksmart-app/components/src/segment/useAnalytics';
import { type FC } from 'react';
import { useLocation } from 'react-router';

import styles from './style.module.scss';
import type { ChatOption } from './types';
import { inferModuleFromPathname } from './utils/inferModuleFromPathname';

interface ChatOptionsProps {
  options: ChatOption[];
}

export const ChatOptions: FC<ChatOptionsProps> = ({ options }) => {
  const amplitude = useAmplitude();
  const { pathname } = useLocation();
  const { user } = useRisksmartUser();
  const module = inferModuleFromPathname(pathname);
  const role = user?.orgRole;

  if (!options || options.length === 0) {
    return null;
  }

  const handleClick = (option: ChatOption) => {
    void amplitude.track({
      event_type: 'AI Assistant Starter Clicked',
      event_properties: {
        id: option.id,
        label: option.label,
        module: module ?? 'default',
        role: role ?? 'unknown',
        source: option.source ?? 'static',
      },
    });
    option.action();
  };

  return (
    <div className={styles.optionsContainer} data-testid={'chat-options'}>
      <h4 className={styles.optionsTitle}>
        {'Or select one of these options'}
      </h4>
      <div className={styles.optionsList}>
        {options.map((option) => (
          <button
            key={option.id}
            className={styles.optionButton}
            onClick={() => handleClick(option)}
            data-testid={`chat-option-${option.id}`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
